import { Controller } from "@hotwired/stimulus"

// Enables a color <input> only while its "custom color" checkbox is checked. A
// disabled input isn't submitted, so unchecked means "inherit the default" (the
// theme accent for headers, gray for body) rather than forcing a hex.
export default class extends Controller {
  static targets = ["input"]

  toggle(event) {
    this.inputTarget.disabled = !event.target.checked
  }
}
